import { useTranslation } from "react-i18next";

import { NoDataBanner } from "../NoDataBanner/NoDataBanner";
import { SectionHeader } from "../SectionHeader";
import { SectionLayout } from "../SectionLayout";

import { KeysList } from "./KeysList";

import { useCall } from "@/hooks/useCall/useCall";

export function SectionKeyTopics() {
  const { call } = useCall();
  const { t } = useTranslation();

  if (!call) {
    return null;
  }

  return (
    <SectionLayout data-test="key-topics-section">
      <SectionHeader>{t("call_context.key_topics")}</SectionHeader>
      {call.keyTopics?.length ? (
        <KeysList keys={call.keyTopics} />
      ) : (
        <NoDataBanner
          text={t("call_context.no_key_topics_generated")}
          data-test="no-key-topics-generated"
        />
      )}
    </SectionLayout>
  );
}
